<div class="col-12 group-edit" *ngIf="!hasLoaded">
  <h1 class="h1-responsive">Assessment Batteries</h1>
</div>
<div class="col-12 group-edit" *ngIf="hasLoaded">
    <h1 class="h1-responsive">Assessment Batteries</h1>
    <div class="row" *hasPermission="'SuperUser'">
      <div class="col">
        <input class="form-control" id="showGroups" type="checkbox"
        (click)="reloadGroups($event)" [checked]="showGroups" name="showGroups" />
        <label for="showGroups"  (click)="reloadGroups($event)">
          Show all Batteries</label>
      </div>
    </div>
    <div>
        <div class="input-group">
            <input type="text" class="form-control" [(ngModel)]="NewGroupName" *hasPermission="'SuperUser'" 
                (keypress)="addGroupFromKeypress($event)"
                placeholder="Enter a name for the battery...">
            <span class="input-group-btn">
                <button class="btn btn-default btn-primary" type="button" (click)="addGroup()" *hasPermission="'SuperUser'">Add</button>
            </span>
        </div><!-- /input-group -->
    </div>
<p *ngIf="Groups.length < 1">There are no batteries created.  Add a assessment battery here...</p>
<ul class="list-group">
  <li class="list-group-item d-flex justify-content-between align-items-center list-group-item-action" *ngFor="let group of Groups"
  (click)="toggleGroup(group)"
  >
    <div>
      {{group.name}}
      <span *ngIf="!group.Show" class="fa fa-chevron-down" 
        aria-hidden="true"></span>
      <span *ngIf="group.Show" class="fa fa-chevron-up" 
        aria-hidden="true"></span>
      <div *ngIf="group.Show">
        <ul>
          <li *ngFor="let assessment of group.Assessments">{{assessment.name}}</li>
        </ul>
        <div *hasPermission="'SuperUser'">
          <input *ngIf="!group.ShowAdd" class="btn btn-primary" type="button" type="button" (click)="toggleShowAdd(group, $event)" value="Add Assessment">
              <input *ngIf="group.ShowAdd" class="btn btn-primary" type="button" type="button" (click)="toggleShowAdd(group, $event)" value="Close Add Screen">
          <dac-assessment-picker *ngIf="group.ShowAdd" (selected)="addAssessmentToGroup(group, $event)"></dac-assessment-picker>
        </div>
        <div *hasPermission="'SuperUser'">
          <input class="btn btn-primary" type="button" (click)="updateAssessmentVersions(group, $event)" value="Update Assessment Versions" />
        </div>
      </div>
    </div>
    <span class="badge badge-primary badge-pill">{{getTokensRemaining(group)}}</span>
  </li>
</ul>
</div>


// WEBPACK FOOTER //
// ./src/app/admin/assessment-group-edit/assessment-group-edit.component.html